import { fetchFilterDefs } from '@api/services/titles';
import { IndexName } from '@enums/IndexName';
import useLoad from '@hooks/useLoad';
import FilterDefinition from '@models/FilterDefinition';
import { stringComparator } from '@utils/arrayUtils';

const sortFilterDefs = (filterDefs?: FilterDefinition[]) =>
  filterDefs?.sort((a, b) => stringComparator(a.displayName, b.displayName));

const useFilterDefsQuery = (indexName: IndexName) =>
  useLoad(() => fetchFilterDefs(indexName), ['filter-defs', indexName], {
    dataTransformer: sortFilterDefs,
  });

export default useFilterDefsQuery;
